// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"submenu_wrapper__jalXk","submenu":"submenu_submenu__zXKUp","subitemLink":"submenu_subitemLink__0MV35","subitemLinkDark":"submenu_subitemLinkDark__GL9in"};